import { Button } from 'react-bootstrap'
import { FileDown } from 'lucide-react'
import { Tooltip } from 'react-tooltip'

export default function PDF(props) {

    const { onClick, tooltip_content } = props

    return (
        <>
            <Button
                variant="outline-danger"
                size='sm'
                onClick={onClick}
                className='ms-1'
                data-tooltip-id='pdf'
                data-tooltip-content={tooltip_content}
                data-tooltip-place="bottom"
            >
                <FileDown className='mb-1' size={14} />
            </Button>

            <Tooltip id='pdf' className='bg-danger' style={{ zIndex: '9', lineHeight: '1' }} />
        </>
    )
}
